import {
  DELIVERY_CHANNEL_LIST,
  DeliveryChannel,
  formatDeliveryChannelSelectLabel,
} from '@shared/api/giftCoupon/giftCoupon.interface';

export type TabType = 'refund' | 'renewal';

export interface ApproveModalState {
  couponId: string;
  type: TabType;
  itemName: string;
  priceWhole: string;
  priceRetail: string;
  priceRebate: string;
  deliveryChannel: DeliveryChannel | '';
  refundAmount: string;
  choiceUnitName?: string;
  choiceUnitPrice?: number;
  giftItemName?: string;
  giftItemPrice?: number;
  refundBasePrice?: number;
  refundBaseSource?: 'choiceUnit' | 'giftItem';
  refundBank?: string;
  refundAccountNumber?: string;
  refundAccountHolder?: string;
  refundPhoneNumber?: string;
  recipientName?: string;
}

export const DELIVERY_CHANNEL_SELECT_OPTIONS: Array<{
  value: DeliveryChannel | '';
  label: string;
}> = [
  ...DELIVERY_CHANNEL_LIST.map((ch) => ({
    value: ch,
    label: formatDeliveryChannelSelectLabel(ch),
  })),
  { value: '', label: '입력안함' },
];
